import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		base: 'w-full flex flex-col px-2 lg:px-0 mx-auto max-w-[82rem]',
		tagText: 'col-span-4 lg:col-span-6',
		contentWrapper: 'mt-2 grid grid-cols-1 md:grid-cols-4 gap-2 md:gap-3 lg:mt-3',
		content:
			'md:col-span-2 flex flex-col space-y-2 lg:space-y-3',
	},
})

export type ManifestoVariants = VariantProps<typeof styles>
